'use client'
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/zones/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getZones = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getZones($lang: String, $limit: Int, $skip: Int, $where: ZoneFilter, $order: [ZoneOrder]) {
          zoneCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
            total
            items{
              __typename
              sys { id }
              id
              title
              subtitle
              slug
              category{id title slug}
              description
              featuredBanner{${IMAGE_QUERY}}
              banner{${IMAGE_QUERY}}
              imageBg{${IMAGE_QUERY}}
              startingPrice
              currencyCode
              backgroundColor
              carousalCollection(limit: 10){items{${IMAGE_QUERY}}}
              zoneLogo{${IMAGE_QUERY}}
              zoneIcon{${IMAGE_QUERY}}
              sponsorLogo{${IMAGE_QUERY}}
              button{ label link }
              location{${LOCATION_QUERY}}
              schedule{${SCHEDULE_QUERY}}
              season{title slug}
              terms
              visibility
              showResellBanner
            }
          }
        }
      `,
      __spreadProps(__spreadValues({
        order: "order_ASC"
      }, props), {
        lang: getContentfulSafeLocale(props.lang),
        where: __spreadValues(__spreadValues({}, commonWhere), props.where)
      })
    );
    return res.zoneCollection;
  } catch (error) {
    throw new Exception({ error, name: "getZonesException" });
  }
});
var useGetZones = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getZones", props],
    queryFn: () => getZones(props)
  }, options));
};

export {
  getZones,
  useGetZones
};
//# sourceMappingURL=chunk-T7SL4HJ5.mjs.map